import Modal from './Modal';
import ModalHeader from './ModalHeader';
import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import ModalTabs from './ModalTabs';
import { Modal as AntModal } from 'antd';

// Attach sub-components for compound pattern usage
// Usage: <Modal.Header />, <Modal.Body />, <Modal.Footer />, <Modal.Tabs />
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
Modal.Tabs = ModalTabs;

// Attach Ant Design static imperative methods as pass-throughs.
// This allows callers that import Modal from the design-system to call
// Modal.confirm(), Modal.warning(), Modal.error(), Modal.info(), Modal.success()
// without a separate `import { Modal as AntModal } from 'antd'`.
Modal.confirm = AntModal.confirm;
Modal.warning = AntModal.warning;
Modal.error = AntModal.error;
Modal.info = AntModal.info;
Modal.success = AntModal.success;
Modal.destroyAll = AntModal.destroyAll;

// Named exports
export { Modal, ModalHeader, ModalBody, ModalFooter, ModalTabs };

// Default export with sub-components attached
export default Modal;
